import React, { useState } from 'react'
import { AiOutlineCaretRight } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom'
import { sidebarLinks } from '../../../data/dashboard-links';
import DashboardLink from '../dashboard/DashboardLink';
import { useDispatch } from 'react-redux';
import { VscSignOut } from 'react-icons/vsc';

const DashboardDropDown = ({ user, logOut }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [drop, setDrop] = useState(false);
    return (
        <div>
            <div
                onClick={() => setDrop(drop ? false : true)}
            >
                <div className="flex w-full pb-4 pl-4 items-center gap-x-2 hover:text-richblack-25">
                    <img
                        src={user?.image}
                        alt={user?.firstName}
                        className="aspect-square w-[25px] rounded-full object-cover"
                        loading='lazy'
                    />
                    <span className='flex items-center gap-x-1'>
                        Dashboard {
                            drop ? <AiOutlineCaretRight className="text-richblack-100 transition-all duration-300 -rotate-[90deg]" /> :
                                <AiOutlineCaretRight className="text-richblack-100  transition-all duration-300 rotate-[90deg]" />
                        }
                    </span>
                </div>
            </div>
            {drop && (
                <div className='flex flex-col gap-y-5 mb-4 pl-4'>
                    {sidebarLinks.map((link) => {
                        if (link.type && link?.type !== user.accountType) return null;
                        return <DashboardLink key={link.id} link={link} />
                    })}
                    <DashboardLink link={{ name: 'Settings', path: 'dashboard/settings', icon: 'VscSettingsGear' }} />
                </div>
            )}
            <div
                onClick={() => {
                    dispatch(logOut(navigate));
                }}
                className={`flex w-full items-center gap-x-2 py-[5px] ${drop ? 'pl-4' : 'pl-8'} text-richblack-100 hover:bg-richblack-700 hover:text-richblack-25`}
            >
                <VscSignOut className="text-lg" />
                Log Out
            </div>
        </div>
    )
}

export default DashboardDropDown